import type { Context } from 'react';
import { createContext } from 'react';

import type { EditorView } from '@atlaskit/editor-prosemirror/view';

// Provides the main page editor's EditorView to components rendered inside a Legacy Content Macro (LCM).
// LCMs create an isolated nested editor, so components like TableOfContentsLiveComponent use this
// context to access the full page document instead of being limited to the LCM's nested content.
export const OuterEditorViewContext: Context<EditorView | undefined> = createContext<
	EditorView | undefined
>(undefined);
